import { CarImageType } from "../data/bruktbilsalgBackend/types/car.types";

export const getSortedCarImages = (images: CarImageType[]) =>
  images.sort((a, b) => {
    if (a.sortOrder && b.sortOrder) {
      return a.sortOrder - b.sortOrder;
    }
    return 0;
  });
